'use strict';

/* global $ */

class Tabs {
    constructor(options) {
        this.opt = $.extend(true, {}, {
            menu: options.selector+'__menu',
            menuItem: options.selector+'__menu-item',
            block: options.selector+'__block',
        }, options);

        let self = this;
        $(this.opt.selector).each(function() {
            self.init(this);
        });
    }
    init(el) {
        console.log('[ Tabs/Init ]');
        let $el = $(el);
        let opt = this.opt;
        console.log($el.find(opt.menuItem));
        $el.find(opt.menuItem).on('click', function(e) {
            //e.preventDefault();
            console.log('[ Tabs/Toggle ]');
            $el.find(opt.menuItem).removeClass('is-active');
            $(this).addClass('is-active');
            let id = $(this).attr('href');
            console.log(id);
            if (id[0] !== '#') return true;
            e.preventDefault();
            $el.find(opt.block).removeClass('is-show');
            $el.find(opt.block).filter(id).addClass('is-show');
            $el.find(opt.block).filter(id + '_ext').addClass('is-show');
            let minHeight = $el.find(opt.block).filter(id).outerHeight();
            $el.css('minHeight', minHeight);
        });

        if (!$el.find(opt.menuItem + '.is-active').length) $el.find(opt.menuItem).eq(0).click();
    }
}

export {
    Tabs
};
